import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLocation } from 'react-router-dom';
import { LogOut, ShieldCheck } from 'lucide-react';
import { useMsal } from '@azure/msal-react';
import { setAuthTokenProvider } from '@/auth/token';
import { useAppStore } from '@/store/app';
import { api } from '@/lib/api';
const TITLES = {
    '/': 'Dashboard',
    '/sources': 'Sources',
    '/inference': 'Inference',
    '/analysis': 'Analysis',
    '/chat': 'Q&A Chat',
    '/settings': 'Settings',
};
export function Topbar() {
    const loc = useLocation();
    const { instance, accounts } = useMsal();
    const setAuthToken = useAppStore((state) => state.setAuthToken);
    const currentUser = useAppStore((state) => state.currentUser);
    const title = TITLES[loc.pathname] ?? 'EY Video Analyzer';
    const account = accounts[0];
    const displayName = currentUser?.name ?? account?.name ?? currentUser?.email ?? account?.username ?? 'EYVA user';
    const roleLabel = currentUser?.is_admin ? 'Admin' : 'User';
    const logout = async () => {
        try {
            await api.logout();
        }
        catch {
            // Always proceed with client-side sign out even when backend logout call fails.
        }
        finally {
            setAuthTokenProvider(null);
            setAuthToken(null);
            void instance.logoutRedirect({ account });
        }
    };
    // Source selector and health pill removed — the per-page camera pickers
    // and the API status indicator in the sidebar footer cover both roles.
    return (_jsxs("header", { className: "topbar", children: [_jsxs("div", { className: "topbar-left", children: [_jsx("h2", { children: title }), _jsxs("span", { className: "breadcrumb", children: ["EY Video Analyzer / ", _jsx("span", { children: title })] })] }), account && (_jsxs("div", { className: "topbar-right", children: [_jsxs("div", { className: "user-pill", title: account.username, children: [_jsx(ShieldCheck, { size: 15 }), _jsx("span", { children: displayName }), _jsx("strong", { children: roleLabel })] }), _jsxs("button", { className: "btn btn-secondary btn-sm", type: "button", onClick: logout, title: "Sign out", children: [_jsx(LogOut, { size: 14 }), "Sign out"] })] }))] }));
}
